import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addNewBarcodes: translate({
      id: 'form.drivers.view.labels.addNewBarcodes',
    }),
    addNewBarcodesHelperText: translate({
      id: 'form.drivers.view.labels.addNewBarcodes.helperText',
    }),
  }))

  return api
}
